import React from 'react';
import { Link } from 'react-router-dom';
import { containerClass, ctaClass, Arrow, Eyebrow, sectionTitleClass } from '../components/ui';
import { usePageMeta } from '../hooks/usePageMeta';

const NotFoundPage: React.FC = () => {
  usePageMeta({
    title: 'Seite nicht gefunden | Flugsportverein Otto Lilienthal',
    description: 'Die angeforderte Seite existiert nicht. Zur Startseite des Flugsportvereins Otto Lilienthal Bad Langensalza.',
    path: '/404',
    noindex: true,
  });

  return (
    <section className={`${containerClass} py-16 lg:py-24`}>
      <Eyebrow>Fehler 404</Eyebrow>
      <h1 className={`${sectionTitleClass} mb-4`}>Seite nicht gefunden</h1>
      <p className="mb-8 max-w-[52ch] text-base leading-normal text-gray-600 lg:text-[17px]">
        Die angeforderte Seite gibt es leider nicht (mehr). Auf der Startseite finden Sie Rundflüge, Ausbildung und alle Informationen zum Flugplatz.
      </p>
      <Link to="/" className={ctaClass}>
        Zur Startseite <Arrow />
      </Link>
    </section>
  );
};

export default NotFoundPage;
